import { render, staticRenderFns } from "./Propose.vue?vue&type=template&id=ca5b61f2"
import script from "./Propose.vue?vue&type=script&lang=js"
export * from "./Propose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports